import { CustomerAuthGuard } from '@/pages/customer-portal/auth/CustomerAuthGuard';
import { CustomerMustChangePasswordGuard } from '@/pages/customer-portal/auth/CustomerMustChangePasswordGuard';
import { CustomerPortalLayout } from '@/pages/customer-portal/layout/CustomerPortalLayout';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/customer/_customer-authenticated')({
	component: CustomerAuthenticatedLayout,
});

function CustomerAuthenticatedLayout() {
	return (
		<CustomerAuthGuard>
			<CustomerMustChangePasswordGuard>
				<CustomerPortalLayout />
			</CustomerMustChangePasswordGuard>
		</CustomerAuthGuard>
	);
}
